import React, {Fragment} from 'react'
import { Link } from 'react-router-dom'

const BlockStyleTen = () => {
    return (
        <Fragment>
            <div className="block-style-ten">
                <div className="section-title mb-45 pe-xxl-5" data-aos="fade-up">
                    <h6 className="sub-title-two mb-20">접근 제어 시스템</h6>
                    <h3 className="sect-title mb-25">체계적인 접근 권한 관리로 내부 위협을 차단합니다</h3>
                    <p className="mb-15">역할 기반 접근 제어(RBAC), 다중 인증(MFA), 단일 로그인(SSO) 연동으로 임직원 계정 보안을 강화합니다.</p>
                    <p>특권 계정 관리(PAM)와 세션 모니터링으로 내부 위협 및 권한 남용을 실시간으로 감지하고 차단합니다.</p>
                    <Link className="theme_btn mt-55" to="/contact">보안 상담 신청하기</Link>
                </div>
            </div>
        </Fragment>
    )
}

export default BlockStyleTen
